import { RUN_NAMES_FILTER_TEXT } from './texts';

/**
 * @typedef {object} RunNameOption
 * @property {string} title
 * @property {string} subtitle
 */

/**
 * Produce the autocomplete options for the run-name filter.
 *
 * The input is a free-form string typed by the user. When non-empty, a single
 * synthesized option is returned so selecting it adds a token to the filter
 * store. Empty input yields no options.
 *
 * @param {string} typed
 * @returns {RunNameOption[]}
 */
export const buildRunNameOptions = (typed) => {
	if (!typed) return [];
	return [
		{
			title: typed,
			subtitle: RUN_NAMES_FILTER_TEXT.optionSubtitle,
		},
	];
};
